<p-floatlabel variant="on">
  <input pInputText id="search-label" [(ngModel)]="searchTerm" autocomplete="off" />
  <label for="search-label"><i class="pi pi-search"></i> Search</label>
</p-floatlabel>

<p-panel header="Equipment" [toggleable]="true" class="innerHeader">
  <div class="p-grid" id="equipmentPanelList" cdkDropList [cdkDropListData]="allEquipment | equipmentFilter: searchTerm"
    [cdkDropListConnectedTo]="multidayDragAndDropService.allCDKEquipmentListIds" (cdkDropListDropped)="drop($event)">
    @for (equip of allEquipment | equipmentFilter: searchTerm; track equip) {
      <app-equipment-card class="p-md-4 p-sm-6 lessPad match-height-card"
        [equipment]="equip" cdkDrag
        (cdkDragStarted)="startDrag($event)">
      </app-equipment-card>
    }
  </div>
</p-panel>
<p-panel header="Employees" [toggleable]="true" class="innerHeader">
  <div class="p-grid" id="employeePanelList" cdkDropList [cdkDropListData]="allEmployees | peopleFilter: searchTerm"
    [cdkDropListConnectedTo]="multidayDragAndDropService.allCDKEmployeeListIds" (cdkDropListDropped)="drop($event)">
    @for (employee of allEmployees | peopleFilter: searchTerm; track employee) {
      <app-employee-card class="p-md-4 p-sm-6 lessPad match-height-card"
        [employee]="employee" cdkDrag>
      </app-employee-card>
    }
  </div>
</p-panel>